
import { getToken } from "../../utils/tokenUtils";
import { getRequest, postRequest } from "../../config/AxiosConfig";
import API_URLS from '../../config/BackendConfig';

const prodBaseUrl = API_URLS.PROD;


// Utility to get authorization headers
const getAuthHeaders = () => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Verify Pan 
export const verifyPan = async ({ api_id, api_key, token_id, pan_number}) => {
  try {
    const payload = {
        "api_id": api_id,
        "api_key": api_key,
        "token_id": token_id,
        "pan_number": pan_number
    };

    const response = await postRequest({
        url: `${prodBaseUrl}pan/verification`,
      headers: getAuthHeaders(),
      data: payload,
    });
     
    return response;
  } catch (error) {
    console.error("Error Pan Verfiy:", error.response?.data || error.message);
    throw error;
  }
};



export const verifyPanV2Service = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export const verifyPanPlusService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan/plus`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export const verifyPanFormService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/form206ab-compliance-status`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}



export const verifyPanToUdyamService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/pan`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}



export const pantoUdyam = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/pan-to-udyam`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export const udyamBasic = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/udyam/basic`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export const generateOtpForMobileToUdyamLookup = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/mobile-to-udyam-lookup`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}

export const generateOtpForUdyamAdvance = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/kyb/udyam/advance`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}






export const verifyVoterIdService = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/voter`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const verifyPassportV2Service = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/passport`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}
export const verifyDlServiceV2 = async (payload) => {
  try {
    const response = await postRequest({
      url: `${prodBaseUrl}srv2/validation/dl`,
      headers: getAuthHeaders(),
      data: payload,
    });
    return response;
  } catch (error) {
    return error;
  }
}







